import { Backdrop } from "@mui/material";
import loadingGif from "../PG23.gif";
import { useSelector } from "react-redux";
export default function Loading() {
  const { Loading } = useSelector((state) => state.globalStates);
  return (
    <div>
      <Backdrop
        sx={{
          color: "#087a75",
          zIndex: (theme) => theme.zIndex.drawer + 10000000000,
        }}
        open={Loading}
      >
        <img src={loadingGif} alt="" className="loading-loader" />
      </Backdrop>
    </div>
  );
}
